import { useState, useEffect } from "react";

export const useExtensionCheck = () => {
  const [isInstalled, setIsInstalled] = useState<boolean | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;

      switch (event.data?.type) {
        case "EXTENSION_FOUND":
          setIsInstalled(true);
          break;
        case "EXTENSION_REMOVED":
          setIsInstalled(false);
          break;
      }
    };

    // Initial check
    window.postMessage({ type: "PING" }, window.location.origin);

    // Set initial state to false after 500ms if no response
    setTimeout(() => {
      setIsInstalled((current) => (current === null ? false : current));
    }, 500);

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return isInstalled;
};
